function checkStatusCpDate(switching_status){
    return switching_status !== "open";
}

export default checkStatusCpDate;